import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavigateRoutes } from 'common/constants/app.constant';
import { SystemService } from './system.service';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    constructor(private systemService: SystemService, private router: Router) {}

    showLoader(message: string = '') {
        if (!document.body.classList.contains('hide-body-overflow')) {
            document.body.classList.add('hide-body-overflow');
        }
        if ([NavigateRoutes.accountStatement, NavigateRoutes.capitalGainStatement].includes(this.router.url)) return;
        this.systemService.loading.next(true);
    }

    hideLoader() {
        if (document.body.classList.contains('hide-body-overflow')) {
            document.body.classList.remove('hide-body-overflow');
        }
        this.systemService.loading.next(false);
    }
}
